import { useCallback, useState } from 'react';
import Toolbar from 'src/components/Toolbar';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import Button, { ButtonTypes } from 'src/components/Button';
import TextContentItem, {
  TextContentItemProps,
} from 'src/components/TextContentItem';
import Checkbox from 'src/components/Checkbox';
import './style.scoped.css';
import { confirmQuitFlow } from 'src/utils';

const data: TextContentItemProps[] = [
  {
    index: 1,
    content: 'Tại thời điểm tham gia Bảo hiểm, NĐBH đang cư trú tại Việt Nam.',
  },
  {
    index: 2,
    content:
      'Bằng việc cung cấp số điện thoại di động, địa chỉ email, tôi/chúng tôi đồng ý để MB Ageas Life gửi đến số điện thoại di động/địa chỉ email của tôi/chúng tôi các thông báo liên quan đến việc thực hiện yêu cầu bảo hiểm/Hợp đồng bảo hiểm và thông tin về các chương trình chăm sóc khách hàng, giới thiệu sản phẩm, dịch vụ của Công ty.',
  },
  {
    index: 3,
    content:
      'Tôi/chúng tôi hiểu rằng việc giao dịch qua email, số điện thoại tiềm ẩn những rủi ro nhất định. Vì vậy, chúng tôi cam kết và đồng ý cập nhật kịp thời cho MB Ageas Life bất kỳ thay đổi nào về thư điện tử, điện thoại, địa chỉ liên lạc cũng như các thông tin cá nhân đã kê khai tại đây.',
  },
  {
    index: 4,
    content:
      'Tôi/chúng tôi hiểu rằng trong trường hợp Người được bảo hiểm tham gia nhiều hơn một Hợp đồng Bảo hiểm tai nạn cá nhân này, MB Ageas Life sẽ giải quyết Quyền lợi bảo hiểm theo Hợp đồng bảo hiểm phát hành đầu tiên có cam kết số 4 này. Các Hợp đồng bảo hiểm tai nạn cá nhân khác có cùng Người được bảo hiểm và có cam kết số 4 này đang còn hiệu lực (nếu có) sẽ bị hủy và MB Ageas Life sẽ hoàn trả Phí bảo hiểm đã đóng của Thời hạn hợp đồng hiện tại (năm Hợp đồng hiện tại) cho Bên mua bảo hiểm.',
  },
  {
    index: 5,
    content:
      'Trong trường hợp HĐBH bị mất hiệu lực theo quy định tại điều 16 quy tắc, điều khoản sản phẩm bảo hiểm, tôi/chúng tôi đề nghị tự động khôi phục hiệu lực HĐBH trong trường hợp được MB Ageas Life chấp nhận, thu phí bảo hiểm thành công và gửi thông báo cho tôi/chúng tôi về việc HĐBH đã được khôi phục hiệu lực.',
  },
  {
    index: 6,
    content:
      'Để phát hành, duy trì hiệu lực HĐBH, tôi/chúng tôi tự nguyên và đồng ý ủy quyền cho MB tự động trích tiền từ (các) Tài khoản thanh toán cá nhân của BMBH tại MB chuyển cho MB Ageas Life để thanh toán phí bảo hiểm ban đầu và phí bảo hiểm định kỳ (với số tiền, thời gian và các nội dung khác do MB Ageas Life gửi thông tin và yêu cầu thu phí bảo hiểm cho MB. Trách nhiệm bảo hiểm phát sinh kể từ thời điểm Phí bảo hiểm lần đầu được trích nộp đầy đủ từ Tài khoản của khách hàng đăng ký tại Yêu cầu bảo hiểm.',
  },
];

const CommitmentSpa = (props) => {
  const { t } = useTranslation();
  const history = useHistory();
  const [isAgreeJoin, setIsAgreeJoin] = useState(false);
  const [isAgreeTerm, setIsAgreeTerm] = useState(false);

  const _handleAgreeJoin = useCallback(() => {
    setIsAgreeJoin(!isAgreeJoin);
  }, [setIsAgreeJoin, isAgreeJoin]);

  const _handleAgreeTerm = useCallback(() => {
    setIsAgreeTerm(!isAgreeTerm);
  }, [setIsAgreeTerm, isAgreeTerm]);

  const _handleContinue = useCallback(() => {
    history.push('/confirm_info_spa');
  }, [history]);

  const _handleClose = () => {
    confirmQuitFlow(history);
  };

  return (
    <div className="screen-container bg-background">
      <Toolbar
        title={t('commitment')}
        type="normal"
        showClose={true}
        onClose={_handleClose}
      />
      <div className="max-w-md mx-auto screenScrollContainer p-4">
        <div className="cardItem">
          <div className="textTitleContainer">{t('commitment_hint')}</div>
          {data.map((item, index) => {
            return (
              <div
                className={
                  index == 0
                    ? 'textContentItemContainerFirst'
                    : index == data.length - 1
                    ? 'textContentItemContainerLast'
                    : 'textContentItemContainer'
                }
              >
                <TextContentItem index={item.index} content={item.content} />
              </div>
            );
          })}
        </div>
        <div className="mb-4">
          <Checkbox
            text={t('im_agree_join_insurance')}
            checked={isAgreeJoin}
            onCheck={_handleAgreeJoin}
            type="card"
          />
        </div>
        <div className="mb-4">
          <Checkbox
            text={t('i_read_and_agree_term')}
            checked={isAgreeTerm}
            onCheck={_handleAgreeTerm}
            type="card"
          />
        </div>
      </div>

      <div className="bottomButtonBlock">
        <div className="flex flex-row">
          <Button
            text={t('continue')}
            buttonType={ButtonTypes.primaryFilled}
            extraClassName="w-full"
            onClick={_handleContinue}
            disabled={!isAgreeJoin || !isAgreeTerm}
          />
        </div>
      </div>
    </div>
  );
};

export default CommitmentSpa;
